import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress, Alert, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useGetVolunteerByIdQuery } from "./api/volunteersApi";
import VolunteerDetail from "./components/VolunteerDetail";

const VolunteerDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: volunteer, isLoading, isError } = useGetVolunteerByIdQuery(id || "");

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !volunteer) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Failed to load volunteer details. Please try again.
        </Alert>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/volunteers')}
          sx={{ mt: 2 }}
        >
          Back to Volunteers
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/volunteers')}
        >
          Back to Volunteers
        </Button>
      </Box>
      
      <VolunteerDetail volunteer={volunteer} />
    </Box>
  );
};

export default VolunteerDetailPage;

